// import Bus from '../FaceTeach/FaceTeachStatistics/bus.js';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import QrcodeVue from "qrcode.vue";

import PreparingCourseware from "components/PreparingCourseware.vue";
import { GetSourceInfo } from 'api/v1.design.courseware';
import directoryConfiguration from "components/directoryConfiguration.vue";

import ManagerShare from "components/ManagerShare.vue";
import SourceListReplace from "components/CatalogSourceListReplace.vue";

import {getVoteInfo} from "api/v1.design.coursechaptersection";
import {
    ContainerMixin,
    ElementMixin,
    HandleDirective
} from 'vue-slicksort';
import SourceList from "components/CatalogSourceList.vue";
const SortableList = {
    name: 'sortablelist',
    mixins: [ContainerMixin],
    template: `
    <ul class='sortable-list'>
      <slot />
    </ul>
  `
}; 
const SortableItem = {
    name: 'sortableitem',
    mixins: [ElementMixin],
    template: `
    <li class='sortable-list-item'>
      <slot />
    </li>
  `
};
export default {
    data() {
        return {
            sourceDataList:[],
            saveSate:false,
            dialogDirectoryConfiguration:false,
            info:{
                CellName:"",
                content:"",
            },
            chapterName:'',
            titleType:"",
            dialogVisibleDiscuss:false,
            dialogVisiblequiz:false,
            dialogVisibleBrainstorming:false,
            managerSchool: false,
            managerPatner: false,
            chapterName: "",
            btnShow: false,
            isImport: {state:false},
            showSchoolCourse:false,
            activityList:[],
            dialogFormVisibleSouce:false,
            dialogVisiblePreviewResources:false,
            activityPagination:{
                pageIndex:1,
                pageSize:10,
                totalCount:10
            },
            checkStatusData: {
                checkBoxState: false
            },
            activityDialogVisible:false,
            setTree: [],
            inputShow: -1,
            fatherIcon: -1,
            fatherIndex: -1,
            fatherInput: -1,
            twoInput: -1,
            childInput: -1,
            threeInput: -1,
            manyInput: -1,
            grandInput: -1,
            fourInput: -1,
            fiveIpnut: -1,
            sixInput: -1,
            oneChild: -1,
            towChild: -1,
            threeChild: -1,
            oneGrand: -1,
            twoGrand: -1,
            threeGrand: -1,
            fourGrand: -1,
            addCourseDialogVisible: false,
            addCourseDialogVisibleMooc: false,
            tdialogVisible: false,
            myfiledialogVisible: false,
            chapterdialogFormVisible: false,
            sectiondialogFormVisible: false,
            folderdialogFormVisible: false,
            picworddialogFormVisible: false,
            visible: false,
            isupload: false,
            isShow: true,
            isfiles: false,
            tuwenName: '',
            content: '',
            folderName: '',
            formLabelWidth: '120px',
            fileList: [],
            uploadUrl: '',
            files: [],
            checkedList: [],
            pageSize: 8,
            pageIndex: 1,
            IsLoad: false,
            userId: '',
            chapterName: '',
            sectionName: '',
            parentId: '',
            level: 0,
            topicId:'',
            parentsId: '',
            firstName: '',
            nodeName: '',
            childNode: '',
            sonsName: '',
            topIndex: '',
            picworddialogFormVisible: false,
            cellId: '',
            item: [],
            Ids: [],
            loadingShow: false,
            fatherId: '',
            grandIndex: '',
            seIndex: '',
            seIndex1: '',
            seIndex2: '',
            tuwenIndex: '',
            tuwenIndex1: '',
            tuwenIndex2: '',
            uploadIndex: '',
            uploadIndex1: '',
            uploadIndex2: '',
            uploadIndex3: '',
            dtype: 0,
            replaceIndex: '',
            replaceIndex1: '',
            replaceIndex2: '',
            replaceIndex3: '',
            prevent: false,
            dialogShow: false,
            // level：当前第几层
            // cellId：不为空时为替换，为空为新增
            // dtype=1 为我的资源 dtype=4为学校资源
            sdialogVisible: false,
            isParticipate: false,
            voteInfo: {
                ActivityName: "",
                ActivityContent: "",
                DocJson: [],
                VoteType: 0,
                DataJson: []
            },
            info: {},
            sourceId: '',
            value:[],
            hierarchy:'',
            showReplaceDialog: false,
            dialogInteract: false,
            dialogHomework: false,
            replaceId: "",
            replaceCellId: "",
            replaceType: 0,
            InteractList: [],
            activityType: "",
            Level1: '第{{index}}章',
			Level2: '第{{index}}节',
			Level3: '第{{index}}讲',
			NumType1: '1',
			NumType2: '1',
            NumType3: '1',
            LevelData:{},
            qrCodeList: [],
            QRImager: [],
            ziplink: 'http://www.clppx.org.cn/wlx/'
        };
    },
    props: {
        courseId: {
            type: String,
            default: 'xwglaaqofilcx9i0-cihha'
        }
    },
    components: {
        ManagerShare,
        SortableItem,
        SortableList,
        SourceList,
        PreparingCourseware,
        directoryConfiguration,
        SourceListReplace,
        QrcodeVue
    },
    directives: {
        handle: HandleDirective
    },
    filters: {
		priceFmt(n,str) {
			if(!/(^[1-9]\d*$)/){
				return '非法数字';
			}
			var nString = n.toString();
			var uppercase='千百亿千百十万千百十个';
			var nLength=nString.length;
			var newStr='';
			if(uppercase.length-nLength<0){
				return '数字过长';
			}
			uppercase=uppercase.substr(uppercase.length-nLength);
			for(var i=0;i<nLength;i++){
				newStr +='零一二三四五六七八九'.charAt(nString[i])+uppercase.charAt(i);
			}
			newStr=newStr.substr(0,newStr.length-1);
			if(nLength < 3){
				newStr = newStr.replace('一十', '十').replace('十零','十');
			}else {
				newStr = newStr.replace('十零','十');
			}
			newStr = newStr.replace('一十', '十').replace('十零','十');
			return str.replace('\{\{index\}\}',newStr);	
        }
    },
    created() {
        var that=this;
        this.getCatalogConfig();
        this.newGetCourseWareTree();
        this.getQRcodeList();
    },
    methods: {
        // 获取导出id 
        getQRcodeList() {
            this.$http.post('/api/XOrg/BookMaterial/getQRcodeList', {
                courseId: this.courseId
            }).then(rst => {
                if (rst.code > 0) {
                    this.qrCodeList = rst.qrCodeList;
                    if (this.ziplink != '') {
                        this.getQRImager();
                    }
                }
            })
        },
        // 拼接网址 生成二维码
        getQRImager() {
            var arr = [];
            this.qrCodeList.forEach(element => {
                let obj = {
                    name: element.name,
                    url: this.ziplink + element.Id + '/bookDetail'
                }
                arr.push(obj);
            });
            this.QRImager = arr;
        },
        // 导出压缩包
        exportImage() {
            var zip = new JSZip();
            var cache = {};
            var cavans = document.querySelectorAll('#qrcodeId');
            if (cavans.length > 0) {
                for (let i = 0; i < cavans.length; i++) {
                    cavans[i].children[0].getContext("2d");
                    let data = cavans[i].children[0].toDataURL("image/png");
                    let fileName = this.QRImager[i].name;
                    zip.file(fileName + '.png', data.substring(22), {
                        base64: true
                    })
                    cache[fileName] = data;
                }
                zip.generateAsync({
                    type: "blob"
                }).then(content => { // 生成二进制流
                    FileSaver.saveAs(content, "二维码.zip") // 利用file-saver保存文件
                })
            }
        },
        Receive(){
            this.saveSate=false;
            this.dialogDirectoryConfiguration=false;
            this.getCatalogConfig();
        },
        //获取课程课件目录配置
        getCatalogConfig() {
            let self = this;
            this.$http.post('/api/XOrg/BookMaterialCatalog/getCoursewareCatalogConfig', {
                courseId: this.courseId
                }).then(function(res) {
                if (res.code > 0) {
                        self.LevelData = res.levelData;
                        self.Level1 = res.levelData.Level1Format;
                        self.NumType1 = res.levelData.Level1Num;
                        self.Level2 = res.levelData.Level2Format;
                        self.NumType2 = res.levelData.Level2Num;
                        self.Level3 = res.levelData.Level3Format;
                        self.NumType3 = res.levelData.Level3Num;
                    }
                });
        },    
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]));
        },
        export2Excel() {
            require.ensure([], () => {
                const { export_json_to_excel } = require("../../../../vendor/Export2Excel");
                const tHeader = [
                "教材名称",
                "模块名称",
                "话题名称",
                "单元名称",
                "url"
                ];
                const filterVal = [
                "bookName",
                "moduleName",
                "topicName",
                "cellName",
                "url",
                ];
                const list = this.sourceDataList;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, "资源表");
            });
        },
        //导出excel提示
        exportTips: function() {
            var that = this;
            that.$http.post("/api/manager/BookMaterial/excelSource",
            {
                courseId:that.courseId,
            }).then(rst => 
            {
                if (rst.code > 0) {
                    that.export2Excel();
                    that.sourceDataList=rst.cellList;
                }
            });
        },
        // 资源子组件传回来的值
        parentReplace(id){
            this.replaceId = id;
        },
        // 替换
        handleCommand(command){
            switch (command.type) {
                case 'ziyuan':
                    this.replaceIndex = command.index;
                    this.replaceIndex1 = command.index1;
                    this.replaceIndex2 = command.index2;
                    this.replaceIndex3 = command.index3;
                    this.replaceLevel = command.level;
                    this.showReplaceDialog = true;
                    this.replaceCellId = command.id;
                    break;
                case 'zuoye':
                    this.replaceIndex = command.index;
                    this.replaceIndex1 = command.index1;
                    this.replaceIndex2 = command.index2;
                    this.replaceIndex3 = command.index3;
                    this.replaceLevel = command.level;
                    this.dialogHomework = true;
                    this.replaceCellId = command.id;
                    this.showhomeWork();
                    break;
                case 'hudong':
                    this.replaceIndex = command.index;
                    this.replaceIndex1 = command.index1;
                    this.replaceIndex2 = command.index2;
                    this.replaceIndex3 = command.index3;
                    this.replaceLevel = command.level;
                    this.dialogInteract = true;
                    this.replaceCellId = command.id;
                    this.getSchoolActivityList();
                    break;
                default:
                    break;
            }
        },
        //获取互动数据
        getSchoolActivityList(){
            var that = this;
            this.$http.post('/api/manager/SchoolCourseShare/getSchoolActivityList',
            {
                courseId: this.courseId,
                activityType: ""
            }).then(rst => {
                if(rst.code > 0){
                    that.InteractList = rst.list;
                    that.activityPagination = res.pagination;
                } else {
                    that.$message.warning(rst.msg);
                } 
            });
        },
        // 资源
        replaceCourseware(){
            this.replaceType = 1;
            this.ReplaceCatalogInfo();
        },
        // 作业
        importHomework(id, type){
            this.replaceType = 5;
            this.replaceId = id;
            this.ReplaceCatalogInfo();
        },
        // 互动
        importInteract(id,type){
            this.replaceId = id;
            this.replaceType = type;
            this.ReplaceCatalogInfo();            
        },
        //替换
        ReplaceCatalogInfo(){
            var that = this;
            this.$http.post('/api/manager/BookMaterial/addCatalogInfo',
            {
                sourceId: this.replaceId,
                type: this.replaceType,
                cellId: this.replaceCellId
            }).then(rst => {
                if(rst.code > 0){
                    // that.newGetCourseWareTree();
                    // let replaceList = [];
                    if(that.replaceLevel ==3){
                        let gatherList = that.setTree[that.replaceIndex].children[that.replaceIndex1].children[that.replaceIndex2];                       
                        Object.assign(gatherList,rst.CellInfo);
                        console.log(that.setTree);
                    } else {
                        let gatherList = that.setTree[that.replaceIndex].children[that.replaceIndex1].children[that.replaceIndex2].children[that.replaceIndex3];
                        Object.assign(gatherList,rst.CellInfo);
                    }                    
                    that.replaceCellId = "";
                    that.replaceId = "";
                    that.showReplaceDialog = false;
                    that.dialogHomework = false;
                    that.dialogInteract = false;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },       

        saveConfigeInfo(){
            this.saveSate=true;
        },
        //批量导入目录
        handleSelectionChangeStu(val) {
            this.checkBoxIds = [];
            val.forEach(row => {
                if (row) {
                this.checkBoxIds.push(row.StudentId);
                }
            });
        },
        // 搜索
        getsearch() {
            let self = this;
            this.loadingShow = true;
            this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
                courseId: self.courseId,
                moduleName:self.chapterName
            }).then(function (res) {
                var chartList = [];
                if (res.code > 0) {
                    if(res.list.length==0){
                        self.setTree=[];
                    }else{
                        res.list.forEach(element => {
                            let obj = {
                                id: element.Id,
                                index: element.index,
                                isFirstModule: element.isFirstModule,
                                name: element.ModuleName,
                                sortOrder: element.sortOrder,
                                Topnode: false,
                                children: []
                            };
                            chartList.push(obj);
                            self.setTree = chartList;
                        });
                    }
                    self.userId = res.userId;
                    self.IsLoad = true;
                    self.loadingShow = false;
                } else {
                    self.$message.warning(res.msg);
                }
            });
        },
        catalogConfigure(){
            this.$router.push({
                name: "directoryConfiguration",
                params: {
                courseId: this.courseId
                }
            });
        },
        // 传值确定导入
        allImport() {
            this.isImport = {state:true};
        },
        //关闭dialog并刷新数据
        closeDialog() {
            this.showSchoolCourse = false;
            this.newGetCourseWareTree();
        },
        // 切换本校、第三方显示隐藏按钮返回函数
        getTabMsg(val) {
            if (val == "0" && this.managerSchool == false) {
            this.btnShow = false;
            } else if (val == "1" && this.managerPatner == false) {
            this.btnShow = false;
            } else {
            this.btnShow = true;
            }
        },
        // 点击本校课程显示隐藏按钮返回函数
        getMsg(val) {
            if (val == true) {
            this.btnShow = true;
            this.managerSchool = true;
            } else {
            this.btnShow = false;
            this.managerSchool = false;
            }
        },
        // 学校库导入完成回调
        ImportCourse() {
            this.showSchoolCourse = false;
        },
        // 点击外校课程显示隐藏按钮返回函数
        getMsgPatner(val) {
            if (val == true) {
            this.btnShow = true;
            this.managerPatner = true;
            } else {
            this.btnShow = false;
            this.managerPatner = false;
            }
        },
        //打开从资源库导入目录弹窗
        importCataLog(){
            this.showSchoolCourse=true;
        },
        // 父组件监听子组件关闭事件
        parentCloseListen(val,list) {
            console.log(list);
            this.dialogFormVisibleSouce = false;
            this.sourceList(list);
        },
        sourceList(list){
            var self = this;
            var sourceList = [];
            list.forEach(element => {
                let obj = {
                    CategoryName: element.CategoryName,
                    CellContent: element.CellContent,
                    CellName: element.CellName,
                    CellType: element.CellType,
                    CourseId: element.CourseId,
                    DateCreated: element.DateCreated,
                    DateModified: element.DateModified,
                    DocId: element.DocId,
                    ParentId: element.ParentId,
                    ResId: element.ResId,
                    TableName: element.TableName,
                    TopicId: element.TopicId,
                }
                sourceList.push(obj);
            })
            if(self.level == 3){
                self.setTree[self.seIndex].children[self.seIndex1].children.push(sourceList[0]);
                self.activityDialogVisible = false;
                self.getTreedata(self.topicId,self.seIndex,self.seIndex1);

            }else if(self.level == 4){
                self.setTree[self.seIndex].children[self.seIndex1].children[self.seIndex2].children.push(sourceList[0]);
                self.getFourdata(self.parentsId,self.seIndex,self.seIndex1,self.seIndex2,self.level);
                self.activityDialogVisible = false;
            }
        },
        handleClose(){
            this.activityDialogVisible=false;
            this.dialogFormVisibleSouce=false;
            this.checkStatusData = {
                checkBoxState: true
            };
        },
        // 互动导入
        saveCourseProcessCellComment(activtyId,activitytype){
            var self=this;
            this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellComment', {
                courseId: this.courseId,
                topicId:this.topicId,
                cellLevel:this.level,
                cellId:this.cellId,
                parentId:this.parentsId,
                activtyId:activtyId,
                maxSortOrder:this.maxSortOrder,
                activitytype:activitytype,
            }).then(function (res) {
                if (res.code > 0) {
                    let list = [];
                    res.cellList.forEach(element => {
                        let obj = {
                            CategoryName: element.CategoryName,
                            CellContent: element.CellContent,
                            CellName: element.CellName,
                            CellType: element.CellType,
                            CourseId: element.CourseId,
                            DateCreated: element.DateCreated,
                            DateModified: element.DateModified,
                            DocId: element.DocId,
                            ParentId: element.ParentId,
                            ResId: element.ResId,
                            TableName: element.TableName,
                            TopicId: element.TopicId,
                        }
                        list.push(obj);
                    })
                    if(self.level == 3){
                        self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children.push(list[0]);
                        self.activityDialogVisible = false;
                        self.getTreedata(self.topicId,self.tuwenIndex,self.tuwenIndex1);

                    }else if(self.level == 4){
                        self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].children.push(list[0]);
                        self.getFourdata(self.parentsId,self.tuwenIndex,self.tuwenIndex1,self.tuwenIndex2,self.level);
                        self.activityDialogVisible = false;
                    }
                    
                } else {
                    self.$message.warning(res.msg);
                }
            });
        },
        //添加互动弹窗中的分页方法
        onHandleSizeChange(pageSize){
            this.activityPagination.pageSize=pageISize;
            this.showInteraction(this.activityType);
        },
        //添加互动弹窗中的分页方法
        onPageChangeHandler(pageIndex){
            this.activityPagination.pageIndex=pageIndex;
            this.showInteraction(this.activityType);
        },
        //获取互动中的活动
        getInteraction(topicId, level, parentsId,type,index,index1,index2){
            this.activityDialogVisible = true;
            this.activityType=type;
            this.topicId = topicId;
            this.level = level;
            this.parentsId = parentsId;
            this.tuwenIndex = index;
            this.tuwenIndex1 = index1;
            this.tuwenIndex2 = index2;
            if(type==5){
                this.showhomeWork();
            }else{
                this.showInteraction(this.activityType);
            }
            
        },
        getInteraction_(topicId, level, parentsId, index, index1,type){
            this.activityDialogVisible = true;
            this.activityType=type;
            this.topicId = topicId;
            this.level = level;
            this.parentsId = parentsId;
            this.tuwenIndex = index;
            this.tuwenIndex1 = index1;
            if(type==5){
                this.showhomeWork();
            }else{
                this.showInteraction(this.activityType);
            }
            
        },
        //获取互动弹窗中的数据
        showInteraction(type){
            var self=this;
            this.activityType=type;
            this.$http.post('/api/XOrg/CourseSectionIndex/getInteraction', {
                courseId: this.courseId,
                activityType:this.activityType,
                page:this.activityPagination.pageIndex
            }).then(function (res) {
                if (res.code > 0) {
                    self.activityList = res.actlist;
                    self.activityPagination = res.pagination;

                } else {
                    self.$message.warning(res.msg);
                }
            });
        },
        //获取作业弹窗中的数据
        showhomeWork(){
            var self=this;
            this.$http.post('/api/XOrg/CourseSectionIndex/getTaskList', {
                courseId: this.courseId,
                page:this.activityPagination.pageIndex
            }).then(function (res) {
                if (res.code > 0) {
                    self.activityList = res.actlist;
                    self.activityPagination = res.pagination;
                } else {
                    self.$message.warning(res.msg);
                }
            });
        },
        // 初始化获取数据（第一层）
        newGetCourseWareTree() {
            let self = this;
            this.loadingShow = true;
            this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
                    courseId: self.courseId
                }).then(function (res) {
                    var chartList = [];
                    if (res.code > 0) {
                        res.list.forEach(element => {
                            let obj = {
                                id: element.Id,
                                index: element.index,
                                isFirstModule: element.isFirstModule,
                                name: element.ModuleName,
                                sortOrder: element.sortOrder,
                                Topnode: false,
                                children: []
                            };
                            chartList.push(obj);
                            self.setTree = chartList;
                        });
                        self.userId = res.userId;
                        self.IsLoad = true;
                        self.loadingShow = false;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 获取第二层数据
        getNode(id, index) {
            let self = this;
            this.grandIndex = index;
            this.grandId = id;
            this.loadingShow = true;
            var packing = [];
            if(this.setTree[index].children == ''){
            this.$http.post('/api/XOrg/CourseSectionIndex/getTopicSectionList', {
                    courseId: this.courseId,
                    ModuleId: id
                }).then(function (res) {
                    if (res.code > 0) {
                        if (res.list != '') {
                            res.list.forEach(element => {
                                let obj = {
                                    id: element.Id,
                                    index: element.index,
                                    name: element.TopicName,
                                    sortOrder: element.sortOrder,
                                    upTopicId: element.upTopicId,
                                    Twonode: false,
                                    children: []
                                };
                                packing.push(obj);
                            });
                            self.$set(self.setTree[self.grandIndex], 'children', packing);
                            // 判断当前Topnode来实现展开收起
                            let setList = self.setTree[self.grandIndex].Topnode;
                            if (setList == false) {
                                self.$set(self.setTree[self.grandIndex], 'Topnode', true);
                            } else {
                                self.$set(self.setTree[self.grandIndex], 'Topnode', false);
                            }
                        } else {
                            let setList = self.setTree[self.grandIndex].Topnode;
                            if (setList == false) {
                                self.$set(self.setTree[self.grandIndex], 'Topnode', true);
                            } else {
                                self.$set(self.setTree[self.grandIndex], 'Topnode', false);
                            }
                        }
                        self.loadingShow = false;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
            }else{
                let setList = self.setTree[self.grandIndex].Topnode;
                if (setList == false) {
                    self.$set(self.setTree[self.grandIndex], 'Topnode', true);
                } else {
                    self.$set(self.setTree[self.grandIndex], 'Topnode', false);
                }
            }
        },
        // 第三层显示背景  获取第三层的数据
        revealIcon(id, index, index1) {
            this.fatherIcon = index;
            this.fatherIndex = index1;
            this.fatherId = id;
            this.loadingShow = true;
            let self = this;
            if(this.setTree[index].children[index1].children == ''){
                this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
                        courseId: this.courseId,
                        topicId: id
                    }).then(function (res) {
                        if (res.code > 0) {
                            let list = [];
                            res.list.forEach(element => {
                                let obj = { 
                                    CategoryName: element.CategoryName,
                                    CellContent: element.CellContent,
                                    CellName: element.CellName,
                                    CellType: element.CellType,
                                    CourseId: element.CourseId,
                                    DateCreated: element.DateCreated,
                                    DateModified: element.DateModified,
                                    DocId: element.DocId,
                                    DocSize: element.DocSize,
                                    ExternalLinkUrl: element.ExternalLinkUrl,
                                    Id: element.Id,
                                    ImpCourseId: element.ImpCourseId,
                                    ImpDocId: element.ImpDocId,
                                    ImpDocTitle: element.ImpDocTitle,
                                    NewSortOrder: element.NewSortOrder,
                                    PageCount: element.PageCount,
                                    ParentId: element.ParentId,
                                    RarJsonData: element.RarJsonData,
                                    ResId: element.ResId,
                                    ResourceUrl: element.ResourceUrl,
                                    SortOrder: element.SortOrder,
                                    TableName: element.TableName,
                                    TopicId: element.TopicId,
                                    VideoQuestionCount: element.VideoQuestionCount,
                                    VideoTimeLong: element.VideoTimeLong,
                                    ztWay: element.ztWay,
                                    paperType:element.paperType,
                                    threeNode: false,
                                    children: []
                            }
                                list.push(obj);
                            });
                            self.$set(self.setTree[index].children[index1], 'children', list);

                            if (self.setTree[index].children[index1].Twonode == false) {
                                self.$set(self.setTree[index].children[index1], 'Twonode', true);
                            } else if (self.setTree[index].children[index1].Twonode == true) {
                                self.$set(self.setTree[index].children[index1], 'Twonode', false);
                            } else {
                                self.$set(self.setTree[index].children[index1], 'Twonode', true);
                            }
                            self.loadingShow = false;
                        } else {
                            self.$message.warning(res.msg);
                        }
                    });
            }else{
                if (self.setTree[index].children[index1].Twonode == false) {
                    self.$set(self.setTree[index].children[index1], 'Twonode', true);
                } else if (self.setTree[index].children[index1].Twonode == true) {
                    self.$set(self.setTree[index].children[index1], 'Twonode', false);
                } else {
                    self.$set(self.setTree[index].children[index1], 'Twonode', true);
                }
            }
        },
        // 获取第四层
        childIcon(id,index, index1, index2,type) {
            this.oneChild = index;
            this.towChild = index1;
            this.threeChild = index2;
            var self = this;
            if(type == 4){
                this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
                    courseId: this.courseId,
                    topicId: id
                }).then(function (res) {
                    if(res.code>0){
                        self.$set(self.setTree[index].children[index1].children[index2], 'children', res.list);
                        if (self.setTree[index].children[index1].children[index2].threeNode == false) {
                            self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
                        } else if (self.setTree[index].children[index1].children[index2].threeNode == true) {
                            self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', false);
                        } else {
                            self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
                        }
                    }
                })
            }
        },
        // 目录文件、互动预览
        previewFile(Id, type, sourceId, ResId, paperType) {
            //9.问卷调查,8.讨论,11.头脑风暴,5.测验,10.提问,6 作业
            if (type == 1) {
              this.sourceId = sourceId;
              GetSourceInfo(this.sourceId).then(rst => {
                if (rst.status === -1) {
                  Message.warning('文件转换失败不能预览');
                } else if (rst.status === -2) {
                  Message.warning('文件正在转换请稍后预览');
                } else if (rst.status === 1) {
                  if (rst.docType === 7) {
                    window.open(rst.docPriviewUrl,'_blank')
                  } else {
                    this.dialogVisiblePreviewResources = true;
                  }
                }
              });
            } else if (type == 5) {
                this.$router.push({
                name: "checkschoolehomework",
                params: {
                  courseId: this.courseId,
                  paperId: ResId
                }
              })
            //   window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');
            } else if (type == 3) {
              this.getContentInfo(Id);
            } else {
              if (type == 7) {
                this.getVote(ResId);
              } else if (type == 9) {
                this.$router.push({
                    name: "ShareSurveyCourseView",
                    params: {
                        courseId: this.courseId,
                        questionnaireId: ResId
                    }
                })
                // window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');
              } else if(type == 8){
                this.discuss(ResId);
              } else if(type==10){
                this.quiz(ResId);
              }else if(type == 11){
                this.Brainstorming(ResId);
              }
              else if(type == 6){
                  //题库
                  if(paperType==1){
                    this.$router.push({
                        name: "checkschoolehomework",
                        params: {
                            courseId: this.courseId,
                            paperId: ResId
                        }
                    })
                    //登分
                  }else if(paperType==2){
                    this.$router.push({
                        name: "checkschoolehomework",
                        params: {
                            courseId: this.courseId,
                            paperId: ResId
                        }
                    })
                    //附件
                  }else if(paperType==4){
                    this.$router.push({
                        name: "checkschoolEnclosure",
                        params: {
                            courseId: this.courseId,
                            paperId: ResId
                        }
                    })
                    
                  }
                
                // window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');
              }
            }
        },
        // 获取投票详情
        getVote: function(Id) {
            getVoteInfo(Id).then(rst => {
                this.isParticipate = true;
                this.titleType="投票";
                this.voteInfo.ActivityName = rst.voteInfo.ActivityName;
                this.voteInfo.ActivityContent = rst.voteInfo.ActivityContent;
                this.voteInfo.DocJson = rst.voteInfo.DocJson.split(";");
                this.voteInfo.VoteType = rst.voteInfo.VoteType;
                this.voteInfo.DataJson = JSON.parse(rst.voteInfo.DataJson);
                this.voteInfo.DocJson.pop();
            });
        },
        // 获取讨论详情
        discuss: function(Id) {
            var that=this;
            this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
                acativtyId: Id
            }).then(function (res) {
                that.dialogVisibleDiscuss = true;
                that.info.CellName=res.activtyInfo.ActivityName;
                that.info.content=res.activtyInfo.ActivityContent;
            });
        },
        // 获取头脑风暴详情
        Brainstorming: function(Id) {
            var that=this;
            this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
                acativtyId: Id
            }).then(function (res) {
                that.dialogVisibleBrainstorming = true;
                that.info.CellName=res.activtyInfo.ActivityName;
                that.info.content=res.activtyInfo.ActivityContent;
            });
        },
        // 获取提问详情
        quiz: function(Id) {
            var that=this;
            this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
                acativtyId: Id
            }).then(function (res) {
                that.titleType="提问";
                that.isParticipate = true;
                that.voteInfo.ActivityName = res.activtyInfo.ActivityName;
                that.voteInfo.ActivityContent = res.activtyInfo.ActivityContent;
                that.voteInfo.DocJson = res.activtyInfo.DocJson.split(";");
                that.voteInfo.VoteType = res.activtyInfo.VoteType;
                that.voteInfo.DataJson = JSON.parse(res.activtyInfo.DataJson);
                that.voteInfo.DocJson.pop();
            });
        },
        // 获取文本内容详情
        getContentInfo(Id) {
            let self = this;
            this.$http.post('/api/XOrg/CourseSectionIndex/getContentInfo', {
                Id: Id,
            }).then(function (res) {
                self.info = res.info[0];
                self.sdialogVisible = true;
            });
        },
        dialogClose() {
            this.dialogVisiblePreviewResources = false;
            this.isParticipate = false;
        },
        // 作业测验查看
        previewQuestion(cell) {
            if (cell.ResId != '') {
                this.$router.push({
                    name: 'courseWareQuestionBank',
                    params: {
                        courseId: this.courseId,
                        cellId: cell.id,
                        cellType: cell.cellType
                    }
                });
            } else {
                this.$message.warning('课件不存在');
            }
        },
        //添加章弹窗显示
        handleAddTop() {
            this.chapterdialogFormVisible = true;
        },
        //添加章
        chapterAdd() {
            this.prevent = true;
            if (this.chapterName == '') {
                this.chapterName = '新建模块';
            }
            let self = this;
            this.$http.post('/api/XOrg/CourseSectionIndex/saveModule', {
                    Id: '',
                    courseId: this.courseId,
                    moduleName: this.chapterName
                }).then(function (res) {
                    if (res.code > 0) {
                        let list = [];
                        res.list.forEach(element => {
                            let obj = {
                                id: element.Id,
                                courseId: element.CourseId,
                                name: element.ModuleName,
                                sortOrder: element.sortOrder,
                                Topnode: false,
                                children: []
                            };
                            list.push(obj);
                        });
                        self.setTree.push(list[0]);
                        self.chapterName = '';
                        self.prevent = false;
                        self.$message.success('新建章成功！');
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
            this.chapterdialogFormVisible = false;
        },
        //添加节弹窗显示
        addSection(moduleId, index) {
            this.sectiondialogFormVisible = true;
            this.moduleId = moduleId;
            this.topIndex = index;

        },
        //添加节
        sectionAdd() {
            this.prevent = true;
            if (this.sectionName == '') {
                this.sectionName = '新建节点';
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveTopic', {
                    courseId: this.courseId,
                    moduleId: this.moduleId,
                    topicId: '',
                    topicName: this.sectionName
                })
                .then(function (res) {
                    if (res.code > 0) {
                        let list = [];
                        res.list.forEach(element => {
                            let obj = {
                                id: element.Id,
                                name: element.TopicName,
                                courseId: element.CourseId,
                                moduleId: element.ModuleId,
                                sortOrder: element.sortOrder,
                                children: []
                            };
                            list.push(obj);
                        });
                        self.setTree[self.topIndex].children.push(list[0]);
                        self.getTwodata(self.moduleId,self.topIndex);
                        self.sectionName = '';
                        self.prevent = false;
                        self.$message.success(res.msg);
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
            this.sectiondialogFormVisible = false;
        },
        // 节点删除
        twoThreeNodeDelete(id, index, index1, index2, index3) {
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/deleteCell', {
                    Id: id
                })
                .then(function (res) {
                    if (res.code > 0) {
                        if (index3 == undefined) {
                            let list = self.setTree[index].children[index1].children;
                            list.splice(index2, 1);
                        } else {
                            let list =
                                self.setTree[index].children[index1].children[index2].children;
                            list.splice(index3, 1);
                        }
                        self.$message.warning(res.msg);
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 删除节点
        NodeDel(d, n, index, index1, index2, index3) {
            if (d.children && d.children.length !== 0) {
                this.$message.error('此节点有子级，不可删除！');
                return false;
            } else {
                let DelFun = () => {
                    if (n.level === 1) {
                        let self = this;
                        this.$http.post('/api/XOrg/CourseSectionIndex/deleteModule', {
                                Id: d.id=="undefined"?d.Id:d.id
                            }).then(function (res) {
                                if (res.code > 0) {
                                    let list = self.setTree;
                                    list.splice(index, 1);
                                    self.$message.warning(res.msg);
                                } else {
                                    self.$message.warning(res.msg);
                                }
                            });
                    } else if (n.level === 2) {
                        let self = this;
                        this.$http.post('/api/XOrg/CourseSectionIndex/deleteTopic', {
                                Id: d.id
                            }).then(function (res) {
                                if (res.code > 0) {
                                    let list = self.setTree[index].children;
                                    list.splice(index1, 1);
                                    self.$message.warning(res.msg);
                                } else {
                                    self.$message.warning(res.msg);
                                }
                            });
                    } else if (n.level === 3) {
                        this.twoThreeNodeDelete(d.Id, index, index1, index2);
                    } else if (n.level === 4) {
                        this.twoThreeNodeDelete(d.Id, index, index1, index2, index3);
                    }
                };
                //二次确认
                let ConfirmFun = () => {
                    this.$confirm('是否确认删除？', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            DelFun();
                        })
                        .catch(() => { });
                };
                //判断是否是新增节点
                d.id > this.non_maxexpandId ? DelFun() : ConfirmFun();
            }
        },
        //新建文件夹弹窗显示
        addFolder(topicId, item, index, index1) {
            this.folderdialogFormVisible = true;
            this.topicId = topicId;
            this.item = item;
            this.seIndex = index;
            this.seIndex1 = index1;
        },
        //打开资源
        getSource(topicId,level,parentsId,index,index1,index2) {
            this.dialogFormVisibleSouce = true;
            this.topicId = topicId;
            // this.item = item;
            this.level = level;
            this.seIndex = index;
            this.seIndex1 = index1;
            this.seIndex2 = index2;
            this.parentsId = parentsId;
        },
        //新建文件夹
        folderAdd() {
            this.prevent = true;
            if (this.folderName == '') {
                this.folderName = '新建文件夹';
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellNode', {
                    Id:"",
                    courseId: this.courseId,
                    topicId: this.topicId,
                    cellName: this.folderName
                })
                .then(function (res) {
                    let list = [];
                    if (res.code > 0) {
                        res.cellList.forEach(element => {
                            let obj = {
                                Id: element.Id,
                                CategoryName: element.categoryName,
                                CellType: element.cellType,
                                CourseId: element.courseId,
                                FromType: element.fromType,
                                ParentId: element.parentId,
                                SortOrder: element.sortOrder,
                                children: []
                            };
                            list.push(obj);
                        });
                        self.setTree[self.seIndex].children[self.seIndex1].children.push(
                            list[0]
                        );
                        self.getTreedata(self.topicId,self.seIndex,self.seIndex1);
                        self.folderName = '';
                        self.prevent = false;
                        self.$message.warning(res.msg);
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
            this.folderdialogFormVisible = false;
        },
        //打开图文添加窗口
        addtuwenwindow(topicId, level, parentsId, hierarchy, index, index1, index2) {
            this.topicId = topicId;
            this.level = level;
            this.parentsId = parentsId;
            this.tuwenIndex = index;
            this.tuwenIndex1 = index1;
            this.tuwenIndex2 = index2;
            this.hierarchy = hierarchy.hierarchy;
            this.tdialogVisible = true;
        },
        // 添加图文 
        savetuwen() {
            let self = this;
            if (self.hierarchy == 2) {
                this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellPicWord', {
                        courseId: self.courseId,
                        topicId: self.topicId,
                        cellLevel: 3,
                        cellId: '',
                        parentId: self.parentsId,
                        cellName: self.tuwenName,
                        cellContent: self.content,
                        rarJsonData: ''
                    })
                    .then(function (res) {
                        if (res.code > 0) {
                            let list = [];
                            res.cellList.forEach(element => {
                                let obj = {
                                    Id: element.Id,
                                    CategoryName: element.categoryName,
                                    CellName: element.cellName,
                                    CellType: element.cellType,
                                    CourseId: element.courseId,
                                    IsAllowDownLoad: element.isAllowDownLoad,
                                    ParentId: element.parentId,
                                    ResourceUrl: element.resourceUrl,
                                    SortOrder: element.sortOrder
                                };
                                list.push(obj);
                            });
                
                            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children.push(list[0]);
                            console.log(self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children);
                            self.getTreedata(self.topicId,self.tuwenIndex,self.tuwenIndex1);
                            self.$message.warning(res.msg);
                        } else {
                            self.$message.warning(res.msg);
                        }
                    });
                self.tdialogVisible = false;
            } else if (self.hierarchy == 3) {
                this.$http
                    .post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellPicWord', {
                        courseId: self.courseId,
                        topicId: self.topicId,
                        cellLevel: 4,
                        cellId: '',
                        parentId: self.parentsId,
                        cellName: self.tuwenName,
                        cellContent: self.content,
                        rarJsonData: ''
                    })
                    .then(function (res) {
                        if (res.code > 0) {
                            let list = [];
                            res.cellList.forEach(element => {
                                let obj = {
                                    Id: element.Id,
                                    CategoryName: element.categoryName,
                                    CellName: element.cellName,
                                    CellType: element.cellType,
                                    CourseId: element.courseId,
                                    IsAllowDownLoad: element.isAllowDownLoad,
                                    ParentId: element.parentId,
                                    ResourceUrl: element.resourceUrl,
                                    SortOrder: element.sortOrder,
                                    children: []
                                };
                                list.push(obj);
                            });
                            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].children.push(list[0]);

                            self.getFourdata(self.parentsId,self.tuwenIndex,self.tuwenIndex1,self.tuwenIndex2,self.level);

                            // if (self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].threeNode == false) {
                            //     self.$set(self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2], 'threeNode', true);
                            // } 

                            self.$message.warning(res.msg);
                        } else {
                            self.$message.warning(res.msg);
                        }
                    });
                self.tdialogVisible = false;
            }
        },
        canceltuwen() {
            this.tdialogVisible = false;
        },
        // 上移
        moveUp(item, id, index, index1, index2, index3) {
            var currentlyId = id;
            var upId = '';
            var self = this;
            if (index2 == '0') {
                upId = item.children[index2].id;
            } else {
                upId = item.children[index2 - 1].id;
            }
            this.$http
                .post('/api/XOrg/CourseSectionIndex/dragCellPrev', {
                    cellId: currentlyId,
                    prevCellId: upId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // 根据index获取当前位置，当前位置下标减1
                        if (index2 != 0 && index3 == undefined) {
                            let setTreeList = self.setTree[index].children[index1].children[index2 - 1];
                            self.$set(self.setTree[index].children[index1].children, index2 - 1, self.setTree[index].children[index1].children[index2]);
                            self.$set(self.setTree[index].children[index1].children, index2, setTreeList);
                        }
                        if (index3 != 0 && index3 != undefined) {
                            let setTreeList = self.setTree[index].children[index1].children[index2].children[index3 - 1];
                            self.$set(self.setTree[index].children[index1].children[index2].children, index3 - 1, self.setTree[index].children[index1].children[index2].children[index3]);
                            self.$set(self.setTree[index].children[index1].children[index2].children, index3, setTreeList);
                        }
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 下移
        moveDown(item, id, index, index1, index2, index3) {
            var downId = '';
            var currentlyId = id;
            if (item.children.length - 1 == index2) {
                downId = item.children[index2].id;
            } else {
                downId = item.children[index2 + 1].id;
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/dragCellAfter', {
                    cellId: currentlyId,
                    afterCellId: downId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // 根据index获取当前位置，当前位置下标加1
                        if (item.children.length - 1 != index2 && index3 == undefined) {
                            let setTreeList =
                                self.setTree[index].children[index1].children[index2 + 1];
                            self.$set(
                                self.setTree[index].children[index1].children,
                                index2 + 1,
                                self.setTree[index].children[index1].children[index2]
                            );
                            self.$set(
                                self.setTree[index].children[index1].children,
                                index2,
                                setTreeList
                            );
                        }
                        if (item.children.length - 1 != index3 && index3 != undefined) {
                            let setTreeList =
                                self.setTree[index].children[index1].children[index2].children[index3 + 1];
                            self.$set(
                                self.setTree[index].children[index1].children[index2].children,
                                index3 + 1,
                                self.setTree[index].children[index1].children[index2].children[index3]
                            );
                            self.$set(
                                self.setTree[index].children[index1].children[index2].children,
                                index3,
                                setTreeList
                            );
                        }
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        /*************** 上传相关 ********************/
        uphandleChange(file, fileList) {
            this.fileList = fileList;
            this.files = fileList;

            if (this.files.length > 0) {
                this.isShow = false;
                this.isupload = true;
                this.isfiles = true;
            } else {
                this.isShow = true;
                this.isupload = false;
                this.isfiles = false;
            }
        },

        onStartHandler() {
            this.$refs.upload.submit();
        },
        handlePreview() { },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        handChange(file, fileList) {
            this.files = fileList;
            this.isAllUploadComplete();
        },
        handexceed(files, fileList) {
            alert('最多上传7个文件，本次可上传7个文件！');
        },
        handleProgess(event, file, fileList) { },
        handleError(err, file, fileList) {
            console.log(err);
        },
        // 上传成功
        handleSuccess(response, file, fileList) {
            this.successFiles.push(response);

            if (this.isAllUploadComplete()) {
                console.log(this.successFiles);
                this.saveSuccessFiles();
            }
            console.log(response);
            // this.saveLocalDocList();
        },
        saveSuccessFiles() {
            let self = this;
            this.$http
                .post('/api/teacher/ecmdoc/saveEdocFiles', {
                    files: JSON.stringify(self.files),
                    parentId: self.parentId
                })
                .then(function (res) {
                    self.$message({
                        message: '文件上传成功',
                        type: 'success'
                    });
                    self.visible = false;
                    self.isShow = true;
                    self.isupload = false;
                    self.isfiles = false;

                    if (self.isAllUploadComplete()) {
                        self.$emit('done');
                    }
                    console.log(self.files);
                    self.saveLocalDocList();
                    self.fileList = [];
                });
        },
        initUploadVariable() {
            let self = this;

            this.$http.post('/api/common/DFS/getUploadUrl').then(function (res) {
                self.uploadUrl = res.uploadUrl;
            });
        },
        disloagClose() {
            // this.files=[];
            this.successFiles = [];
            this.$emit('done');
        },
        isAllUploadComplete() {
            var flag = true;
            this.files.forEach(function (v) {

                if (v.status != 'success') {
                    flag = false;
                }
            });
            console.log('是否已经完成上传？' + flag);
            return flag;
        },
        cancel: function () {
            this.files = [];
            this.fileList = [];
            this.visible = false;
            this.isShow = true;
            this.isupload = false;
        },
        // //上传（新增）
        // handleCommand(command) {
        //     let self = this;
        //     switch (command.type) {
        //         case 'bendi':
        //             self.visible = true;
        //             self.files = [];
        //             self.successFiles = [];
        //             self.initUploadVariable();
        //             self.topicId = command.topicId;
        //             self.level = command.level;
        //             self.parentsId = command.parentsId;
        //             self.uploadIndex = command.index;
        //             self.uploadIndex1 = command.index1;
        //             self.uploadIndex2 = command.index2;
        //             self.uploadIndex3 = command.index3;
        //             break;
        //         case 'wode':
        //             self.topicId = command.topicId;
        //             self.dtype = 1;
        //             self.myfiledialogVisible = true;
        //             self.edocList();
        //             self.level = command.level;
        //             self.parentsId = command.parentsId;
        //             self.uploadIndex = command.index;
        //             self.uploadIndex1 = command.index1;
        //             self.uploadIndex2 = command.index2;
        //             self.uploadIndex3 = command.index3;
        //             break;
        //         case 'zhijiao':
        //             self.$router.push({
        //                 name: 'icveCourseWare',
        //                 params: {
        //                     courseId: self.courseId,
        //                     topicId: command.topicId,
        //                     parentId: command.parentsId,
        //                     cellId: '0',
        //                     importtype: 1
        //                 }
        //             });
        //             break;
        //         case 'xuexiao':
        //             self.topicId = command.topicId;
        //             self.dtype = 4;
        //             self.myfiledialogVisible = true;
        //             self.edocList();
        //             self.level = command.level;
        //             self.parentsId = command.parentsId;
        //             self.uploadIndex = command.index;
        //             self.uploadIndex1 = command.index1;
        //             self.uploadIndex2 = command.index2;
        //             self.uploadIndex3 = command.index3;
        //             break;
        //     }
        // },
        // // 替换
        // handleCommandChange(command) {
        //     let self = this;
        //     switch (command.type) {
        //         case 'bendi':
        //             self.visible = true;
        //             self.files = [];
        //             self.successFiles = [];
        //             self.initUploadVariable();
        //             self.cellId = command.cellId;
        //             self.replaceIndex = command.index;
        //             self.replaceIndex1 = command.index1;
        //             self.replaceIndex2 = command.index2;
        //             self.replaceIndex3 = command.index3;
        //             break;
        //         case 'wode':
        //             self.dtype = 1;
        //             self.myfiledialogVisible = true;
        //             self.edocList();
        //             self.cellId = command.cellId;
        //             self.replaceIndex = command.index;
        //             self.replaceIndex1 = command.index1;
        //             self.replaceIndex2 = command.index2;
        //             self.replaceIndex3 = command.index3;
        //             break;
        //         case 'zhijiao':
        //             self.$router.push({
        //                 name: 'icveCourseWare',
        //                 params: {
        //                     courseId: self.courseId,
        //                     topicId: command.topicId,
        //                     parentId: command.parentsId,
        //                     cellId: command.cellId,
        //                     importtype: 2
        //                 }
        //             });
        //             break;
        //         case 'xuexiao':
        //             self.dtype = 4;
        //             self.myfiledialogVisible = true;
        //             self.edocList();
        //             self.cellId = command.cellId;
        //             self.replaceIndex = command.index;
        //             self.replaceIndex1 = command.index1;
        //             self.replaceIndex2 = command.index2;
        //             self.replaceIndex3 = command.index3;
        //             break;
        //     }
        // },
        //分页方法
        handleCurrentChange(page) {
            this.edocList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.edocList(1);
        },
        myfilehandleSelectionChange(Id) {
            if (!this.checkedList[Id]) {
                this.checkedList[Id] = false;
                var index = this.Ids.indexOf(Id);
                this.Ids.splice(index, 1);
            } else {
                this.checkedList[Id] = true;
                this.Ids.push(Id);
            }
        },
        /****************** 拖动相关 *********************/
        // 第一层移动
        onInput(newList) {
            var moduleId = [];
            for (var i = 0; i < newList.length; i++) {
                moduleId[i] = newList[i].id;
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveProcessModuleSortData', {
                    moduleIds: moduleId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // self.$message.success(res.msg);
                    } else {
                        // self.$message.warning(res.msg);
                    }
                });
        },
        // 第二层移动
        getInput(newList) {
            var topicId = [];
            for (var i = 0; i < newList.length; i++) {
                topicId[i] = newList[i].id;
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveProcessTopicSortData', {
                    topicIds: topicId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // self.$message.success(res.msg);
                    } else {
                        // self.$message.warning(res.msg);
                    }
                });
        },
        // 第三层移动
        chInput(newList) {
            var childId = [];
            for (var i = 0; i < newList.length; i++) {
                childId[i] = newList[i].Id;
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveProcessCellSortData', {
                    cellIds: childId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // self.$message.success(res.msg);
                    } else {
                        // self.$message.warning(res.msg);
                    }
                });
        },
        // 第四层移动
        grInput(newList) {
            var grandId = [];
            for (var i = 0; i < newList.length; i++) {
                grandId[i] = newList[i].Id;
            }
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveProcessChildCellSortData', {
                    childCellIds: grandId
                })
                .then(function (res) {
                    if (res.code > 0) {
                        // self.$message.success(res.msg);
                    } else {
                        // self.$message.warning(res.msg);
                    }
                });
        },
        sortEnd() { },
        handleChange(val) {
            console.log(val);
        },
        secondHandleChange(val) {
            console.log(val);
        },
        threeHandleChange(val) {
            console.log(val);
        },
        fourHandleChange(val) {
            console.log(val);
        },
        /*******      第一层     ********/
        // 输入框显示
        edit(index, chapterName) {
            this.inputShow = index;
            this.firstName = chapterName;
        },
        // 保存
        grandKeep(name, id) {
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveModule', {
                    Id: id,
                    courseId: this.courseId,
                    moduleName: name
                })
                .then(function (res) {
                    if (res.code > 0) {
                        self.$message.warning(res.msg);
                        self.inputShow = -1;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 取消
        prohibit(item) {
            this.inputShow = -1;
            item.name = this.firstName;
        },
        /*******      第二层     ********/
        onFather(index, index1, name) {
            this.fatherInput = index;
            this.twoInput = index1;
            this.nodeName = name;
        },
        fatherKeep(name, chapterId, id) {
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveTopic', {
                    courseId: this.courseId,
                    moduleId: chapterId,
                    topicId: id,
                    topicName: name
                })
                .then(function (res) {
                    if (res.code > 0) {
                        self.$message.warning(res.msg);
                        self.fatherInput = -1;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        abrogate(item) {
            this.fatherInput = -1;
            item.name = this.nodeName;
        },
        /*******      第三层     ********/
        onChild(index, index1, index2, name) {
            this.childInput = index;
            this.threeInput = index1;
            this.manyInput = index2;
            this.childNode = name;
        },
        childKeep(name, nodeId, id) {
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellNode', {
                    Id:id,
                    courseId: this.courseId,
                    topicId: nodeId,
                    cellName: name
                })
                .then(function (res) {
                    if (res.code > 0) {
                        self.$message.warning(res.msg);
                        self.childInput = -1;
                        self.threeInput = -1;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        childgate(item) {
            this.childInput = -1;
            this.threeInput = -1;
            item.name = this.childNode;
        },
        /*******      第四层     ********/
        onSons(index, index1, index2, index3, name) {
            this.grandInput = index;
            this.fourInput = index1;
            this.fiveIpnut = index2;
            this.sixInput = index3;
            this.sonsName = name;
        },
        sonsKeep(name, id) {
            let self = this;
            this.$http
                .post('/api/XOrg/CourseSectionIndex/savecellname', {
                    courseId: this.courseId,
                    cellId: id,
                    cellName: name
                })
                .then(function (res) {
                    if (res.code > 0) {
                        self.$message.warning(res.msg);
                        self.grandInput = -1;
                        self.fourInput = -1;
                        self.fiveIpnut = -1;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        grandIcon(index, index1, index2, index3) {
            this.oneGrand = index;
            this.twoGrand = index1;
            this.threeGrand = index2;
            this.fourGrand = index3;
        },
        grandgate(item) {
            this.grandInput = -1;
            this.fourInput = -1;
            this.fiveIpnut = -1;
            item.name = this.sonsName;
        },


/****************************  用于添加节点、文件夹、互动 时展开层级  **********************************/
         // 初始化获取数据（第一层）
         getTopdata() {
            let self = this;
            this.loadingShow = true;
            this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
                    courseId: self.courseId
                }).then(function (res) {
                    var chartList = [];
                    if (res.code > 0) {
                        res.list.forEach(element => {
                            let obj = {
                                id: element.Id,
                                index: element.index,
                                isFirstModule: element.isFirstModule,
                                name: element.ModuleName,
                                sortOrder: element.sortOrder,
                                Topnode: false,
                                children: []
                            };
                            chartList.push(obj);
                            self.setTree = chartList;
                        });
                        self.userId = res.userId;
                        self.IsLoad = true;
                        self.loadingShow = false;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 获取第二层数据
        getTwodata(id, index) {
            let self = this;
            this.grandIndex = index;
            this.grandId = id;
            this.loadingShow = true;
            var packing = [];
            this.$http.post('/api/XOrg/CourseSectionIndex/getTopicSectionList', {
                    courseId: this.courseId,
                    ModuleId: id
                }).then(function (res) {
                    if (res.code > 0) {
                        if (res.list != '') {
                            res.list.forEach(element => {
                                let obj = {
                                    id: element.Id,
                                    index: element.index,
                                    name: element.TopicName,
                                    sortOrder: element.sortOrder,
                                    upTopicId: element.upTopicId,
                                    Twonode: false,
                                    children: []
                                };
                                packing.push(obj);
                            });
                            self.$set(self.setTree[self.grandIndex], 'children', packing);
                            // 判断当前Topnode来实现展开收起
                            let setList = self.setTree[self.grandIndex].Topnode;
                            if (setList == false) {
                                self.$set(self.setTree[self.grandIndex], 'Topnode', true);
                            } 
                        }
                        self.loadingShow = false;
                    } else {
                        self.$message.warning(res.msg);
                    }
                });
        },
        // 第三层显示背景  获取第三层的数据
        getTreedata(id, index, index1) {
            this.fatherIcon = index;
            this.fatherIndex = index1;
            this.fatherId = id;
            this.loadingShow = true;
            let self = this;
                this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
                        courseId: this.courseId,
                        topicId: id
                    }).then(function (res) {
                        if (res.code > 0) {
                            let list = [];
                            res.list.forEach(element => {
                                let obj = { 
                                    CategoryName: element.CategoryName,
                                    CellContent: element.CellContent,
                                    CellName: element.CellName,
                                    CellType: element.CellType,
                                    CourseId: element.CourseId,
                                    DateCreated: element.DateCreated,
                                    DateModified: element.DateModified,
                                    DocId: element.DocId,
                                    DocSize: element.DocSize,
                                    ExternalLinkUrl: element.ExternalLinkUrl,
                                    Id: element.Id,
                                    ImpCourseId: element.ImpCourseId,
                                    ImpDocId: element.ImpDocId,
                                    ImpDocTitle: element.ImpDocTitle,
                                    NewSortOrder: element.NewSortOrder,
                                    PageCount: element.PageCount,
                                    ParentId: element.ParentId,
                                    RarJsonData: element.RarJsonData,
                                    ResId: element.ResId,
                                    ResourceUrl: element.ResourceUrl,
                                    SortOrder: element.SortOrder,
                                    TableName: element.TableName,
                                    TopicId: element.TopicId,
                                    VideoQuestionCount: element.VideoQuestionCount,
                                    VideoTimeLong: element.VideoTimeLong,
                                    paperType:element.paperType,
                                    ztWay: element.ztWay,
                                    threeNode: false,
                                    children: []
                                }
                                list.push(obj);
                            });
                            self.$set(self.setTree[index].children[index1], 'children', list);

                            if (self.setTree[index].children[index1].Twonode == false) {
                                self.$set(self.setTree[index].children[index1], 'Twonode', true);
                            } 
                            
                            self.loadingShow = false;
                        } else {
                            self.$message.warning(res.msg);
                        }
                    });
        },
        // 获取第四层
        getFourdata(id,index, index1, index2,type) {
            this.oneChild = index;
            this.towChild = index1;
            this.threeChild = index2;
            var self = this;
            if(type == 4){
                this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
                    courseId: this.courseId,
                    topicId: id
                }).then(function (res) {
                    if(res.code>0){
                        self.$set(self.setTree[index].children[index1].children[index2], 'children', res.list);
                        if (self.setTree[index].children[index1].children[index2].threeNode == false) {
                            self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
                        } 
                    }
                })
            }
        },

    }
};